import React, { useState } from "react";
import api from "../api/api"; // Updated import

const InquiryForm = ({ carId }) => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/inquiries`, {
        carId,
        ...formData,
      });
      setStatus("Inquiry submitted successfully!");
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      setStatus("Failed to submit inquiry.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Name:</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label>Email:</label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label>Message:</label>
        <textarea
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        />
      </div>
      <button type="submit">Submit</button>
      {status && <p>{status}</p>}
    </form>
  );
};

export default InquiryForm;
